import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Dealer.List.IRequest;
type Response = Api.Core.Dealer.List.IResponse;
type Headers = Api.Core.Dealer.List.IHeaders;
const url = '/api/DealerManagement/Dealer';
export default async function dealerListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
